const WL_SEARCH_VENDOR_FILTER = ' -vendor:Michelon*';
const WL_EXACT_SKU_SEARCH_TERMS = new Set([
  'hy-eml01wh',
  'hy-exlcomb01red',
  'hya-t8-8ft-h-twcct(rc)-clear',
  'hya-t8-8ft-h-twcct(rc)-frosted',
]);
const WL_VARIANT_SKU_SEARCH_TERMS = new Set(['hy-eml01wh', 'hy-exlcomb01red']);

function quoteExactSkuSearchTerm(term) {
  const trimmedTerm = (term || '').trim();
  const unquotedTerm = trimmedTerm.replace(/^"|"$/g, '');
  const normalizedTerm = unquotedTerm.toLowerCase();

  if (WL_VARIANT_SKU_SEARCH_TERMS.has(normalizedTerm)) return `variants.sku:"${unquotedTerm}"`;

  return WL_EXACT_SKU_SEARCH_TERMS.has(normalizedTerm) ? `"${unquotedTerm}"` : trimmedTerm;
}

function decorateVendorExcludedSearchTerm(term) {
  const normalizedTerm = (term || '').trim();

  if (!normalizedTerm || normalizedTerm.includes(WL_SEARCH_VENDOR_FILTER.trim())) {
    return normalizedTerm;
  }

  return `${quoteExactSkuSearchTerm(normalizedTerm)}${WL_SEARCH_VENDOR_FILTER}`;
}

function normalizeRawExactSkuSearchUrl() {
  if (window.location.pathname !== '/search') return false;

  const searchParams = new URLSearchParams(window.location.search);
  const rawTerm = searchParams.get('q');
  const trimmedTerm = (rawTerm || '').trim();
  const unquotedTerm = trimmedTerm.replace(/^"|"$/g, '');

  if (!trimmedTerm || !WL_EXACT_SKU_SEARCH_TERMS.has(unquotedTerm.toLowerCase())) return false;

  searchParams.set('q', decorateVendorExcludedSearchTerm(trimmedTerm));
  window.location.replace(`${window.location.pathname}?${searchParams.toString()}${window.location.hash}`);

  return true;
}

window.WLSearchVendorFilter = {
  decorateSearchTerm: decorateVendorExcludedSearchTerm,
  filterSuffix: WL_SEARCH_VENDOR_FILTER,
  normalizeRawExactSkuSearchUrl,
};

normalizeRawExactSkuSearchUrl();

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

function bindVendorExcludedSearchForms(root = document) {
  root.querySelectorAll('form[data-exclude-vendor-search]').forEach((form) => {
    if (form.dataset.vendorExcludeBound === 'true') return;

    form.dataset.vendorExcludeBound = 'true';
    form.addEventListener('submit', (event) => {
      const searchInput = form.querySelector('input[type="search"]');

      if (!searchInput || event.defaultPrevented) return;

      const originalValue = searchInput.value;
      const decoratedValue = decorateVendorExcludedSearchTerm(originalValue);

      setTimeout(() => {
        if (document.documentElement.contains(searchInput)) {
          searchInput.value = originalValue;
        }
      }, 0);

      searchInput.value = decoratedValue;
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => bindVendorExcludedSearchForms());
} else {
  bindVendorExcludedSearchForms();
}
